import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CandidateHome from "@/pages/CandidateHome";
import ProfileEditor from "@/pages/ProfileEditor";
import MediaManager from "@/pages/MediaManager";
import CandidateJobs from "@/pages/CandidateJobs";
import CandidateApplications from "@/pages/CandidateApplications";
import EmployerHome from "@/pages/EmployerHome";
import EmployerOrganization from "@/pages/EmployerOrganization";
import EmployerSearch from "@/pages/EmployerSearch";
import EmployerShortlist from "@/pages/EmployerShortlist";
import EmployerJobs from "@/pages/EmployerJobs";
import AdminHome from "@/pages/AdminHome";
import AdminCandidates from "@/pages/AdminCandidates";
import AdminEmployers from "@/pages/AdminEmployers";
import AdminJobs from "@/pages/AdminJobs";
import AdminApplications from "@/pages/AdminApplications";
import AdminCommunity from "@/pages/AdminCommunity";
import AdminMediaReview from "@/pages/AdminMediaReview";
import AdminBackups from "@/pages/AdminBackups";
import Community from "@/pages/Community";
import Legal from "@/pages/Legal";
import AccountPrivacy from "@/pages/AccountPrivacy";
import AdminAccountRequests from "@/pages/AdminAccountRequests";
import OfflineBanner from "@/components/OfflineBanner";
import { LangProvider } from "@/components/home/i18n";
import Blueprint from "@/pages/Blueprint";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <OfflineBanner />
          <LangProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blueprint" element={<Blueprint />} />
            <Route path="/community" element={<Community />} />
            <Route path="/terms" element={<Legal docKey="terms" />} />
            <Route path="/privacy" element={<Legal docKey="privacy" />} />
            <Route path="/guidelines" element={<Legal docKey="guidelines" />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/candidate" element={<ProtectedRoute roles={["candidate"]}><CandidateHome /></ProtectedRoute>} />
            <Route path="/candidate/profile" element={<ProtectedRoute roles={["candidate"]}><ProfileEditor /></ProtectedRoute>} />
            <Route path="/candidate/media" element={<ProtectedRoute roles={["candidate"]}><MediaManager /></ProtectedRoute>} />
            <Route path="/candidate/jobs" element={<ProtectedRoute roles={["candidate"]}><CandidateJobs /></ProtectedRoute>} />
            <Route path="/candidate/applications" element={<ProtectedRoute roles={["candidate"]}><CandidateApplications /></ProtectedRoute>} />
            <Route path="/employer" element={<ProtectedRoute roles={["employer"]}><EmployerHome /></ProtectedRoute>} />
            <Route path="/employer/organization" element={<ProtectedRoute roles={["employer"]}><EmployerOrganization /></ProtectedRoute>} />
            <Route path="/employer/search" element={<ProtectedRoute roles={["employer"]}><EmployerSearch /></ProtectedRoute>} />
            <Route path="/employer/jobs" element={<ProtectedRoute roles={["employer"]}><EmployerJobs /></ProtectedRoute>} />
            <Route path="/employer/shortlist" element={<ProtectedRoute roles={["employer"]}><EmployerShortlist /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminHome /></ProtectedRoute>} />
            <Route path="/admin/candidates" element={<ProtectedRoute roles={["admin"]}><AdminCandidates /></ProtectedRoute>} />
            <Route path="/admin/employers" element={<ProtectedRoute roles={["admin"]}><AdminEmployers /></ProtectedRoute>} />
            <Route path="/admin/jobs" element={<ProtectedRoute roles={["admin"]}><AdminJobs /></ProtectedRoute>} />
            <Route path="/admin/applications" element={<ProtectedRoute roles={["admin"]}><AdminApplications /></ProtectedRoute>} />
            <Route path="/admin/community" element={<ProtectedRoute roles={["admin"]}><AdminCommunity /></ProtectedRoute>} />
            <Route path="/admin/videos" element={<ProtectedRoute roles={["admin"]}><AdminMediaReview /></ProtectedRoute>} />
            <Route path="/admin/backups" element={<ProtectedRoute roles={["admin"]}><AdminBackups /></ProtectedRoute>} />
            <Route path="/admin/account-requests" element={<ProtectedRoute roles={["admin"]}><AdminAccountRequests /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute roles={["candidate", "employer"]}><AccountPrivacy /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" richColors />
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
